import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { UserProfileResolver } from '@core/Resolver/user-profile.resolver';
import { AuthGuard } from '@core/guard';

const routes: Routes = [
  {
    path: 'login',
    pathMatch: "full",
    loadChildren: () => import('../app/auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: '',
    canActivate: [AuthGuard],
    loadChildren: () => import('./layout/layout.module').then((m) => m.LayoutModule2),
  },
  { path: '**', redirectTo: 'login' , pathMatch: 'full'},
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
